import avatar1 from "images/avatar/Avatar1.svg";
import avatar2 from "images/avatar/Avatar2.svg";
import avatar3 from "images/avatar/Avatar3.svg";
import avatar4 from "images/avatar/Avatar4.svg";
import rate4 from "images/rate4.svg";
import rate5 from "images/rate5.svg";

const data = [
  {
    id: 1,
    name: "علی ایزدی نجف آبادی",
    avatar: avatar1,
    rate: rate5,
    review:
      "عزیزان اگر گوشی میخواین ک یکی دو سال داشته باشین بنظرم مدل s20fe5g بگیرین خصوصیاتش همش همینه فقط صفحه قشنگترین داره s21 هرچند 20 هم عالیه فقط یکم حاشیه صفحه داره... اما اگر میخواین گوشی چند سال داشته باشین بدون شک 21 رو بگیرین چون تا اندروید 15 حتی شاید 16 رو دریافت می‌کنه ! و اینو بدونین شیایومی هیچوقت حس خوبی ک سامسونگ میده بهتون رو ‌نداره و حتی کیفیتش ...",
  },
  {
    id: 2,
    name: "جواد غریب",
    avatar: avatar2,
    rate: rate4,
    review:
      "گوشی قبلی a51 و الان این گوشی به نظرم توی سرعت کیفیت صفحه عالیه. توی باطری اون انتظاری که ازش داشتم نیست ولی بدم نیست گلس اصلی گوشی به سختی پیدا میشه با شارژر ۱۵ واتی سرعت شارژش خوبه دوربینش هم عالیه و در کل ازش راضیم تو ۱۵ روز استفاده .",
  },
  {
    id: 3,
    name: "maryam ferdousian",
    avatar: avatar3,
    rate: rate4,
    review:
      "من بعد از 1 ماه تحقیق زیتونیشو به سختی از بازار پیدا کردم و خریدم کمتر ازین قیمتی که دوستان اینجا میفروشن اونم رنگی که اصلا پیدا نمیشه جایی (همه جا فقط مشکیشه و یاسی و زیتونی چند هفته دیگه وارد بازار میشه) دوستان توجه کنن صحبتایی که راجب داغیش میشه خیلی اغراق شدست و فقط اون اول که گوشی و استارت میکنید و داده انتقال میدید و آپدیتای لازم و انجام میدید کمی حرارتش میره. در نهایت این گوشی با این قیمت یکی از بهترینای بازاره",
  },
  {
    id: 4,
    name: "نیکتا گودرزی",
    avatar: avatar4,
    rate: rate5,
    review:
      "با تقدیم سلام واحترام. ضمن تبریک سال نو و سلامتی برای همه تیم دیجی کالا، من چهار سال پیش گوشی اس ۸ پلاس را از شما خریداری کردم، و بسیار راضی بودم، باخرید این گوشی دوم خواستم تشکر کنم، از اول تا به امروز انشاالله همیشه شاد و سلامت باشید.",
  },
];
export default data;
